'use client';
import Link from 'next/link';
import Image from 'next/image';
import { FaRegCirclePlay } from 'react-icons/fa6';
import { useState } from 'react';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import { VscClose } from 'react-icons/vsc';
import VideoPlayer from '@/components/videoPlayer/videoPlayer';

interface CalloutVideoProps {
  videoUrl: string;
  imageSrc: string;
  blurDataURL: string;
}

export default function CalloutVideo({
  videoUrl,
  imageSrc,
  blurDataURL,
}: CalloutVideoProps) {
  const [modalShow, setModalShow] = useState(false);
  return (
    <Container>
      <Row>
        <Col md={{ span: 10, offset: 1 }}>
          <div className="videoWrap">
            <Link
              href="#"
              role="button"
              aria-label="Play video"
              onClick={(e) => {
                e.preventDefault();
                setModalShow(true);
              }}
            >
              <Image
                src={imageSrc}
                alt="Thumbnail image for video"
                sizes="(max-width: 767px) 100vw, 70vw"
                width={700}
                height={500}
                quality={100}
                placeholder="blur"
                blurDataURL={blurDataURL}
              />
              <span
                className="playIcon"
                style={{ fontSize: '88px' }}
                aria-hidden="true"
              >
                <FaRegCirclePlay />
              </span>
            </Link>
            <Modal
              show={modalShow}
              onHide={() => setModalShow(false)}
              size="lg"
              aria-labelledby="modal-title"
              aria-describedby="modal-description"
              aria-modal="true"
              role="dialog"
              centered
              className="video-modal"
            >
              <Modal.Body className="video-modal-body">
                <Button
                  variant="text"
                  onClick={() => setModalShow(false)}
                  className="close-btn"
                >
                  <VscClose />
                </Button>
                <VideoPlayer url={videoUrl} />
              </Modal.Body>
            </Modal>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
